var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bv-example-row"},[_c('list-table',{attrs:{"url":_vm.url,"title":"لیست لینک های پرداخت هدفدار","fields":_vm.fields,"params":_vm.params,"btns":_vm.btns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }